import type { ApiProblemDetails } from "Infrastructure/Api/Api";

export const COUPON_ERRORS = [
  "CouponNotFound",
  "CouponExpired",
  "CouponOutOfStock",
  "CouponInvalidType",
  "CouponRegionMismatch",
] as const;

export type CouponError = (typeof COUPON_ERRORS)[number];

export const isCouponError = (error: unknown): CouponError | null => {
  if (typeof error === "object" && error !== null && "data" in error) {
    const errors = (error as { data: ApiProblemDetails }).data?.errors;
    if (errors) {
      return COUPON_ERRORS.find((key) => key in errors) ?? null;
    }
  }
  return null;
};
